import React, { useEffect, useState } from "react";
import {
  Form,
  Offcanvas,
  Button,
  Table,
  OverlayTrigger,
} from "react-bootstrap";
import SidebarSlides from "../../components/pgi/SidebarSlides";
import {
  DisplaySettingsOutlined,
  DragHandleOutlined,
  VisibilityOutlined,
  DeleteForeverOutlined,
  ErrorOutline,
} from "@mui/icons-material";
import BloqueTxtPgi from "../../components/pgi/BloqueTxtPgi";
import BannerPubPgi from "../../components/pgi/BannerPubPgi";
import useHome from "../../hooks/useHome";
import usePgiModules from "../../hooks/useModules";
import HomePgiReplica from "./editComponents/HomePgiReplica";
import { useDragDrop } from "../../hooks/useDragDrop";

import Tooltip from "react-bootstrap/Tooltip";
import toast from "react-hot-toast";
import useAudit from "../../hooks/useAudit";

const HomePgi = () => {
  const {
    sliders,
    deleteArticle,
    handleVisibilitySlider,
    handlePublishButton,
    publicSliders,
    banners,
  } = useHome();
  const [showEditHome, setShowEditHome] = useState(true);
  const {
    modules,
    setModules,
    getModulesByParams,
    handleVisibility,
    handleModuleUpdate,
  } = usePgiModules();
  const handleClose = () => setShowEditHome(false);
  const handleShow = () => setShowEditHome(true);
  const { dragStart, dragEnter, drop } = useDragDrop({list: modules, setList: setModules});

  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name

  const { createAuditRequest } = useAudit();

  const arrayBanner = banners?.find((banner) => banner.state === true);

  const handleSliders = (e) => {
    e.preventDefault();
    publicSliders(sliders);
  };

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setModules(
        res.sort(
          (a, b) =>
            a.position?.find((obj) => obj)?.home -
            b.position?.find((obj) => obj)?.home
        )
      )
    });
    document.title = "Personalizar Home | PGI Tensolite";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* const callBell = document.getElementById('callbell-iframe')
    useEffect(() => {
      callBell && document.getElementById('callbell-iframe').classList.add('d-none')
    }, [callBell]) */

  const handleDelete = (sliderId) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          Estas seguro de eliminar este articulo?
        </div>
        <br />
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(sliderId, 'DELETE')}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000,
      }
    );
  };

  const handleConfirmDelete = (sliderId, action) => {
    const sliderDelete = sliders?.filter((slider) => slider._id === sliderId && slider)
    createAuditRequest({...sliderDelete[0], element: 0, deleted: true, creator: user, image_desktop: [], image_tablet: [], image_mobile: []}, action);
    toast.dismiss();
  };

  const arraySliders = sliders?.filter(
    (slide) => slide?.deleted === false 
  );
  return (
    <div id="wrapperEditHome" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi">
        <HomePgiReplica />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditHome}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR HOME</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            id="formEditarHSlider"
            className="basePgi__vista-edit-gral"
            onSubmit={handleSliders}
          >
            <Table>
              <colgroup>
                <col span="1" className="basePgi__table-col-max" />
                <col span="1" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>

              </tbody>
            </Table>
            <header aria-labelledby="formEditarHSlider">
              <h2>Slider</h2>
              <>
                <SidebarSlides />
              </>
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-position" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="3" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {arraySliders?.map(
                  (slider, index) =>
                    slider.deleted === false && (
                      <tr
                        key={slider._id}
                      >
                        <td>
                          {" "}
                          <Button disabled>
                            <DragHandleOutlined />
                          </Button>
                        </td>
                        <td className="pgi__table-position-number">
                          <b>{index + 1}</b>
                        </td>
                        <td>{slider.title}</td>
                        <td onClick={() => handleVisibilitySlider(slider._id)}>
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                          >
                            <Button className={slider.state ? "" : "disabled"}>
                              {" "}
                              <VisibilityOutlined />{" "}
                            </Button>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <SidebarSlides isEdit={true} sliderToEdit={slider} />
                        </td>
                        <td onClick={() => handleDelete(slider._id)}>
                          <OverlayTrigger
                            key="1"
                            placement="top"
                            overlay={<Tooltip id="1">Eliminar</Tooltip>}
                          >
                            <Button>
                              <DeleteForeverOutlined />
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
            {/* <button
              className={
                sliders?.filter((s) => s.state === true && s.deleted === false)
                  .length > 5 ||
                sliders?.filter((s) => s.state === true && s.deleted === false)
                  .length < 3
                  ? "pgi__disabled"
                  : "settings_button-pleno"
              } // falta clase para disabled!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              disabled={
                sliders?.filter((s) => s.state === true && s.deleted === false)
                  .length > 5 ||
                sliders?.filter((s) => s.state === true && s.deleted === false)
                  .length < 3
              }
            >
              Actualizar SLIDERS
            </button>
            <p className="basePgi-comments text-center mt-2">
              Debe cargar entre 3 y 5 sliders
            </p> */}
          </form>
          <hr className="basePgi__space-line" />
          {/******************************FORM MÓDULOS*************************** */}
          <form id="formEditarHModulos" className="basePgi__vista-edit-gral">
            <header aria-labelledby="formEditarHModulos">
              <h2>Módulos</h2>
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-position" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="1" className="basePgi__table-col-min" />
                <col span="1" className="basePgi__table-col-max" />
                <col span="2" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {
                  // mapeo automatico de tabla de modulos
                  modules.map((module, index) => {
                    return (
                      <>
                        <tr
                          key={index}
                          onDragStart={() => dragStart(index)}
                          onDragEnter={() => dragEnter(index)}
                          onDragEnd={() => drop('home')}
                          onDragOver={(e) => e.preventDefault()}
                          draggable
                          className="draggable"
                        >
                          <td>
                            <Button disabled>
                              <DragHandleOutlined />
                            </Button>
                          </td>
                          <td className="pgi__table-position-number">
                            <b>{index + 1}</b>
                          </td>
                          <td className="pgi__module-name">{module.title}</td>
                          <td>{module.moduleType}</td>
                          {module.title === 'Banner_publicitario' ? (
                            <td>
                              {arrayBanner?.title ? arrayBanner?.title : ''}
                            </td>
                          ) : (
                            <td>
                              {module?.content ? module.content[index] : ''}
                            </td>
                          )}

                          <td>
                            <OverlayTrigger
                              key="1"
                              placement="top"
                              overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                            >
                              <Button
                                className={
                                  module.visible.find((item) => item === 'home')
                                    ? ''
                                    : 'disabled'
                                }
                                onClick={() => handleVisibility(module, 'home')}
                              >
                                <VisibilityOutlined />
                              </Button>
                            </OverlayTrigger>
                          </td>
                          {module.editable ? (
                            <td>
                              {/* <Button><ModeEditOutlined/></Button> */}
                              {module.title === 'Bloque_info' && (
                                <BloqueTxtPgi
                                  module={module}
                                  _id={module._id}
                                  title_content={module.title_content}
                                  content={module.content}
                                  alignment={module?.alignment}
                                  fromHome={true}
                                />
                              )}
                              {module.title === 'Banner_publicitario' && (
                                <BannerPubPgi editBannerPub={true} />
                              )}
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      </>
                    )
                  })
                }
              </tbody>
            </Table>

            <button
              type="button"
              className="settings_button-pleno"
              onClick={handleModuleUpdate}
            >
              Actualizar Módulos
            </button>
          </form>
          <hr className="basePgi__space-line" />

          {/****************end form módulos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default HomePgi;
